import * as yup from "yup";
import { ReactSelectOptionSchema } from "./";
import { DefaultUSCountry } from "./Address";
import { ContactTypes } from "../../domain";
import { Phone } from "../../models/contact";
import { Country, CountryInfoToCountry } from "../../models/country";
import { ReactSelectOption } from "../../models/generic";
import "../../utils/YupHelper";

export interface PhoneNumberData {
    contactTypeId: number;
    countryCode: ReactSelectOption | Country;
    number: string;
    extension?: string;
}

export const PhoneNumberSchema = yup.object<PhoneNumberData>().shape({
    contactTypeId: yup.number().label("Type of $parent"),
    countryCode: ReactSelectOptionSchema.label("Country code of $parent"),
    number: (yup.string().label("$parent").max(50) as any).phoneNumber(),
    extension: yup.string().label("Extension of $parent").max(50),
});

export const PhoneNumberSchemaRequired = yup.object<PhoneNumberData>().shape({
    contactTypeId: yup.number().required(),
    countryCode: ReactSelectOptionSchema.required(),
    number: yup.string().required(),
    extension: yup.string(),
}).concat(PhoneNumberSchema);

export const DefaultPhoneNumber: PhoneNumberData = {
    contactTypeId: ContactTypes.Private.id,
    countryCode: DefaultUSCountry,
    number: "",
};

export const PhoneModelToForm = (p: Phone): PhoneNumberData => {
    return {
        contactTypeId: p.contactTypeId,
        countryCode: {
            ...CountryInfoToCountry(p),
            label: p.country,
            value: p.countryCode,
        },
        extension: p.extn || "",
        number: p.number || "",
    };
};



// WEBPACK FOOTER //
// ./src/forms/generic/PhoneNumber.ts